import React, { useMemo } from 'react';
import TableContainer from "../../../Components/Common/TableContainer";
import { CustomerStateBadge } from "../../customer-states/components/CustomerStateBadge";

type CustomersTableProps = {
    data: any[];
    total: number;
    onPageChange: (page: number) => void;
};

export const CustomersTable: React.FC<CustomersTableProps> = ({
    data,
    total,
    onPageChange
}) => {
    const columns = useMemo(
        () => [
            {
                header: "Cédula",
                accessorKey: "document",
                enableColumnFilter: false,
                enableSorting: false,
            },
            {
                header: "Nombres",
                accessorKey: "firstName",
                enableColumnFilter: false,
                enableSorting: false,
            },
            {
                header: "Apellidos",
                accessorKey: "lastName",
                enableColumnFilter: false,
                enableSorting: false,
            },
            {
                header: "Celular / WhatsApp",
                accessorKey: "phone",
                enableColumnFilter: false,
                enableSorting: false,
                cell: (cellProps: any) => {
                    const row = cellProps.row.original;
                    const phone = row?.contacts?.[0]?.waId || row?.jsonData?.phone;
                    return phone ? (
                        <span>{phone}</span>
                    ) : (
                        <span className="text-muted fs-12 italic">-</span>
                    );
                }
            },
            {
                header: "Correo",
                accessorKey: "email",
                enableColumnFilter: false,
                enableSorting: false,
            },
            {
                header: "Estado",
                accessorKey: "state",
                enableColumnFilter: false,
                enableSorting: false,
                cell: (cellProps: any) => {
                    const state = cellProps.row.original.currentState;
                    return state ? (
                        <CustomerStateBadge state={state} />
                    ) : (
                        <span className="text-muted fs-12 italic">-</span>
                    );
                }
            },
            /*
            {
                header: "Acciones",
                enableColumnFilter: false,
                cell: (cell: any) => {
                    return (
                        <React.Fragment>
                            <div className="d-flex flex-row-reverse">
                                <div className="flex-grow-1 tasks_name"></div>
                                <div className="flex-shrink-0 ms-4">
                                    <ul className="d-flex flex-row">
                                        {isAdmin ? (
                                            <React.Fragment>
                                                <li className="d-flex flex-row ">
                                                    <Link
                                                        to="#"
                                                        onClick={() => {
                                                            const taskData = cell.row.original;
                                                            // handleCustomerClick(taskData);
                                                        }}
                                                    >
                                                        <i className="d-flex ri-pencil-fill align-bottom text-muted text-lg"
                                                            style={{ width: "25px", height: "25px" }}></i>
                                                    </Link>
                                                </li>
                                                <li className="list-inline-item">
                                                    <Link
                                                        to="#"
                                                        className="remove-item-btn"
                                                        onClick={() => {
                                                            const taskData = cell.row.original;
                                                            // onClickDelete(taskData);
                                                        }}
                                                    >
                                                        <i className="ri-delete-bin-fill align-bottom me-2 text-muted"></i>
                                                    </Link>
                                                </li>
                                            </React.Fragment>
                                        ) : (
                                            <React.Fragment>
                                                <li className="list-inline-item">
                                                    <Link
                                                        to="#"
                                                        className="w-6 h-8"
                                                        onClick={() => {
                                                            const taskData = cell.row.original;
                                                            // setDetailUser(taskData);
                                                            // toggleUser();
                                                        }}
                                                    >
                                                        <i className="ri-eye-fill align-bottom mr-2 text-muted"></i>
                                                    </Link>
                                                </li>
                                            </React.Fragment>
                                        )}
                                    </ul>
                                </div>
                            </div>
                        </React.Fragment>
                    );
                },
            },*/
        ],
        []
    );

    return (
        <TableContainer
            columns={columns}
            data={data}
            isGlobalFilter={false}
            customPageSize={10}
            total={total}
            onPageChange={onPageChange}
            divClass="table-responsive table-card mb-3"
            tableClass="align-middle table-nowrap mb-0"
            theadClass="table-light"
        />
    );
};
